/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { jsx } from '@atlaskit/css';
import Suspense from '@atlaskit/react-ufo/suspense';

const LazyRovoLoadingGif = React.lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-loading-gif" */ './RovoLoadingGif'
		),
);

export const LazyAnimatedRovoIcon: React.MemoExoticComponent<
	({
		alt,
		testId,
		width,
		height,
	}: {
		alt?: string;
		testId?: string;
		width?: string;
		height?: string;
	}) => JSX.Element
> = React.memo(
	({
		alt = '',
		testId = '',
		width = '',
		height = '',
	}: {
		alt?: string;
		testId?: string;
		width?: string;
		height?: string;
	}): JSX.Element => {
		return (
			<Suspense interactionName="rovo-platform-ui-animated-icon" fallback={null}>
				<LazyRovoLoadingGif alt={alt} testId={testId} width={width} height={height} />
			</Suspense>
		);
	},
);
